<div class="page-container">
  <div class="top-toolbar">
    <div class="sub-title">POWER-PERFORMANCE DECODER OPTIMIZATION</div>
    <div class="title">
      <p>Power-Performance Decoder</p>
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label="Optimization">
      <ng-template matTabContent>
        <app-tabs
          [chartData]="itemData"
          (loadPageAgainWithNewFiles)="onLoadPage()"
          (updateProgressBaseOnNumberOfEntities)="
            updateProgressBaseOnNumberOfEntities($event)
          "></app-tabs>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <mat-tab-group>
    <mat-tab label="Completeness">
      <ng-template matTabContent>
        <div class="progress_div">
          <mat-progress-bar
            style="height: 30px; width: 100%"
            mode="determinate"
            [value]="progressValue"
          ></mat-progress-bar>
          <span class="progress_bar" [ngStyle]="{ left: progressValue / 2 + '%' }">{{ progressValue }}%</span>
          <mat-icon [ngStyle]="{ left: progressValue + 1 + '%' }" *ngIf="showStar" style="position: absolute; color: #f44336; top: 3.5px">star</mat-icon>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <div class="ppd-perform-button u-margin-top-20">
    <button mat-raised-button (click)="performCPTest()">Perform PPD Test</button>
  </div>
  <div>
    <div data-component="cross-validation-ppd-graph" #chartPPD id="chartPPD"></div>
    <br />
    <app-typical-error *ngIf="isShowTypicalError" [typicalErrorList]="typicalErrorList"></app-typical-error>
  </div>
  <div class="actions-div">
    <button
      mat-raised-button
      (click)="handleCancelView(false, true, false, false)"
    >
      Decline
    </button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="isFinalCPCalculated && progressValue === 100"
      (click)="accept(false)"
      mat-button
    >
      Accept
    </button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="isFinalCPCalculated && progressValue === 100"
      (click)="accept(true)"
    >
      Accept and View
    </button>
  </div>
</div>
